<template>
  <div>NotificacionesDetalle</div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export class NotificacionesDetalle extends Vue {}
export default NotificacionesDetalle;
</script>
